import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import { queryOptions } from "@tanstack/react-query";
import { getPublicUpcomingPicks } from "@/lib/publicPicks.functions";
import { hubJsonLd } from "@/lib/picksJsonLd";
import AIPredictions from "@/pages/AIPredictions";
import { MainLayout } from "@/components/layout/MainLayout";

const picksQuery = queryOptions({ queryKey: ["public-upcoming-picks"], queryFn: () => getPublicUpcomingPicks(), staleTime: 5 * 60_000 });

export const Route = createFileRoute("/ai-predictions")({
  loader: ({ context }) => context.queryClient.ensureQueryData(picksQuery),
  head: ({ loaderData }) => ({
    meta: [
      { title: "AI Football Predictions Today: Transparent Tips | Statlign" },
      { name: "keywords", content: seoFor({ topics: ["aiPredictions", "footballPredictions"] }).meta },
      { name: "description", content: "AI football tips across the EPL, Champions League, La Liga and 50+ competitions — each one explained, ranked by confidence, and free to read." },
      { property: "og:title", content: "AI Football Predictions Today: Transparent Tips | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "AI football tips across the EPL, Champions League, La Liga and 50+ competitions — each one explained, ranked by confidence, and free to read." },
      { name: "twitter:title", content: "AI Football Predictions Today: Transparent Tips | Statlign" },
      { name: "twitter:description", content: "AI football tips across the EPL, Champions League, La Liga and 50+ competitions — each one explained, ranked by confidence, and free to read." },
    ],
    scripts: hubJsonLd({ path: "/ai-predictions", name: "AI football predictions", description: "Upcoming AI-analysed football picks with odds, confidence and reasoning.", picks: loaderData ?? [] }),
  }),
  component: () => (
    <MainLayout>
      <AIPredictions />
    </MainLayout>
  ),
});
